// extracted by mini-css-extract-plugin
export var modalContent = "Link-module--modalContent--18369";
export var modalContentActions = "Link-module--modalContentActions--87a20";
export var modalContentCancel = "Link-module--modalContentCancel--58f19";
export var modalContentInner = "Link-module--modalContentInner--3f956";
export var modalContentLink = "Link-module--modalContentLink--95d6d";
export var modalContentMessage = "Link-module--modalContentMessage--9381d";